<mat-dialog-content class="mat-typography" fxLayout="column" simplebar>
    <div class="image-container">
        <img *ngIf="!isDarkMode" src="assets/images/logos/student-projects-color-logo-color-text.svg" alt="soc-logo"/>
        <img *ngIf="isDarkMode" src="assets/images/logos/student-projects-white-logo-white-text.svg" alt="soc-logo"/>
    </div>
    <app-register (signupSuccessful)="handleRegisterDialog($event)"></app-register>
</mat-dialog-content>
